import { getUsers } from '../../services/api/user.api';
import { GET_USER_LIST_REQUEST, GET_USER_LIST_SUCCESS, GET_USER_LIST_FAILURE } from '../types';
import { transformUsers } from '../../transforms/users';
import { transformError } from '../../transforms/error';
import { transformPagination } from '../../transforms/pagination';
import { mapTable } from '../../helpers/table';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: [],
		pagination: {
			pages: 0,
			activePage: 0,
			perPage: 0,
			total: 0,
		},
	},

	getters: {
		tableData: (state) => mapTable(state.data, {
			// left side is transform keys, right side is table field keys
			id: 'id',
			name: 'name',
			email: 'email',
			role: 'role',
			updated_at: 'updated_at',
			is_active: 'is_active',
		}),
	},

	mutations: {
		[GET_USER_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_USER_LIST_SUCCESS](state, { data, meta }) {
			state.isLoading = false;
			state.data = transformUsers(data);
			state.pagination = transformPagination(meta);
		},
		[GET_USER_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getUsers({ commit }) {
			try {
				commit(GET_USER_LIST_REQUEST);
				const { data } = await getUsers();
				commit(GET_USER_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_USER_LIST_FAILURE, error);
			}
		},
	},
};